import { Component, inject, OnInit } from '@angular/core';
import { AppointmentUiComponent } from '../appointment-ui/appointment-ui.component';
import { ReceptionistDashboardService } from './receptionist-dashboard.service';
import { commonImports } from '../shared/table-interface';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ScrolldDirective } from '../scrolld.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AsyncPipe } from '@angular/common';
import { UpcomingActivitiesComponent } from '../unified-activities/upcoming-activities.component';

@Component({
    selector: 'app-receptionist-dashboard',
    standalone: true,
    imports: [...commonImports, AppointmentUiComponent,UpcomingActivitiesComponent, ScrolldDirective, MatIconModule, MatTooltipModule, AsyncPipe],
    templateUrl: './receptionist-dashboard.component.html',
    styleUrls: ['../admin-dashboard/admin-dashboard.component.scss', './receptionist-dashboard.component.scss']
})
export class ReceptionistDashboardComponent implements OnInit {
    private receptionistService = inject(ReceptionistDashboardService);
    private router = inject(Router);

    pendingRegistrations$: Observable<number> = this.receptionistService.getPendingRegistrationsCount$();
    activePatients$: Observable<number> = this.receptionistService.getActivePatientsCount$();
    pharmacyWalkIns$: Observable<number> = this.receptionistService.getPharmacyWalkInPatientsCount$();

    ngOnInit(): void {
        // Initial data load already handled by observables
    }

    navigateToRegistration(): void {
        this.router.navigate(['/app/patient-registration/pending']);
    }

    navigateToApprovedPatients(): void {
        this.router.navigate(['/app/patient-registration/approved']);
    }

    navigateToActivePatients(): void {
        this.router.navigate(['/app/patient-registration/approved']);
    }

    navigateToPharmacyWalkIns(): void {
        this.router.navigate(['/app/patient-registration/approved'], {
            queryParams: { patientType: 'pharmacy-walkin' }
        });
    }
}
